import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MessageIcon from '@mui/icons-material/Message';
import { Button, Divider, Skeleton } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import TenantPage from 'layouts/TenantPage';
import { toInteger } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { notificationService } from 'shared/services';
interface NotificationPayload {
  id: number;
  read: boolean;
  notification: {
    title: string;
    message: string;
    timestamp: string;
  };
}

export const NotificationDetail = () => {
  const { t } = useTranslation();
  const prefix = 'global.notification';
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  //const [notificationID, setNotificationID] = useState('');
  const [notification, setNotification] = useState<NotificationPayload | null>(null);

  useEffect(() => {
    notificationService
      .get(toInteger(window.location.pathname.split('/')[4]))
      .then((res: NotificationPayload) => {
        setNotification(res);

        if (!res.read) {
          notificationService.update(res.id, { read: true });
        }
      })
      .catch((err) => {
        console.error('Failed to fetch notification parameters:', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <TenantPage
      title={t(`${prefix}.title`)}
      subtitle={t(`${prefix}.subtitle`)}
      menuRight={
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          sx={{ textTransform: 'none', fontWeight: 500 }}
          onClick={() => navigate('..')}>
          Vai alla lista
        </Button>
      }>
      <Card
        variant="outlined"
        sx={{
          maxWidth: 1400,
          borderRadius: 3,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.03)'
        }}>
        <CardContent sx={{ p: 4, '&:last-child': { pb: 4 } }}>
          {loading ? (
            /* Loading State Shimmer Map */
            <Box display="flex" flexDirection="column" gap={2}>
              <Skeleton variant="text" width="150px" height={20} />
              <Skeleton variant="text" width="60%" height={40} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={120}
                sx={{ borderRadius: 2, mt: 2 }}
              />
            </Box>
          ) : notification ? (
            /* Main Content Presentation Layer */
            <Box>
              {/* Header: Timestamp Metadata */}
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                sx={{ color: 'text.secondary', mb: 1 }}>
                <CalendarTodayIcon sx={{ fontSize: 16 }} />
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  {dayjs(notification.notification.timestamp).format('DD/MM/YYYY HH:mm')}
                </Typography>
              </Box>

              {/* Title Header */}
              <Typography
                variant="h5"
                component="h1"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 3 }}>
                {notification.notification.title}
              </Typography>

              <Divider sx={{ my: 2 }} />

              {/* Section Anchor: Message Label */}
              <Box display="flex" alignItems="center" gap={1} sx={{ mb: 1.5, mt: 2 }}>
                <MessageIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    color: 'text.primary'
                  }}>
                  {t(`${prefix}.message`)}
                </Typography>
              </Box>

              {/* Message Content Container */}
              <Box
                sx={{
                  p: 3,
                  bgcolor: 'action.hover',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  wordBreak: 'break-word',
                  color: 'text.secondary',
                  lineHeight: 1.6
                }}>
                {notification.notification.message}
              </Box>
            </Box>
          ) : (
            /* Error or Missing Resource Empty State */
            <Typography variant="body1" color="error" textAlign="center">
              {t('global.error_resource_not_found')}
            </Typography>
          )}
        </CardContent>
      </Card>
      {/* <Card sx={{ minWidth: 275, maxWidth: 1400 }}>
        <CardContent className="">
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            {notificationDate}
          </Typography>
          <Typography variant="h5" component="div">
            {notificationTitle}
          </Typography>
          <br />
          <Typography variant="h5" component="div">
            {t(`${prefix}.message`)}
          </Typography>
          <div className="p-8">
            <div className="break-all">{notificationMessage}</div>
          </div>
        </CardContent>
      </Card> */}
    </TenantPage>
  );
};
